<img [src]="imgSrc" alt="{{ 'PAGE.image_alt' | translate }}" />
<h1>{{ 'COMPONENT.ERROR_PAGE.title_error_message' | translate }}</h1>
<h3>{{ 'COMPONENT.ERROR_PAGE.text_page_not_found' | translate }}</h3>
